import { Gift } from 'lucide-react'
import { cn } from '../../lib/cn'
import { Badge } from '../ui'

interface GiftableBadgeProps {
  /**
   * Display name of the one member missing this game (v1: exactly one). The
   * feed payload carries user ids only — the caller resolves the name from
   * the roster it already has.
   */
  missingName: string | null
  /** An open GiftPurchase already exists for this pick. */
  proposed?: boolean
  onClick?: () => void
  className?: string
}

/**
 * Small feed badge for a giftable pick (rec.giftable, §3.7). Standalone —
 * ResultCard integration happens in the feed pass-through work.
 */
export function GiftableBadge({ missingName, proposed = false, onClick, className }: GiftableBadgeProps) {
  const label = proposed
    ? 'Gift proposed'
    : missingName
      ? `Giftable — only ${missingName} is missing this`
      : 'Giftable'

  const badge = (
    <Badge
      variant="ember"
      icon={<Gift className="h-3.5 w-3.5" strokeWidth={1.75} />}
      className={onClick ? undefined : className}
    >
      {label}
    </Badge>
  )

  if (!onClick) return badge

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'rounded-chip transition hover:opacity-85 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ember-400 focus-visible:ring-offset-2 focus-visible:ring-offset-canvas',
        className,
      )}
    >
      {badge}
    </button>
  )
}
